// Global
export const UNLOCK_FULL_ACCESS_MODAL_NAME = 'unlock-full-access-modal'
export const USER_PROFILING_WIZARD_MODAL_NAME = 'user-profiling-wizard-modal'
export const USER_POST_PURCHASE_PROFILING_WIZARD_MODAL_NAME =
  'user-post-purchase-profiling-wizard-modal'
export const RECORDING_FEATURE_PRESENTATION_MODAL_NAME =
  'recording-feature-presentation-modal'

// Mentor profile
export const EDIT_AVATAR_MODAL_NAME = 'edit-avatar-modal'
export const EDIT_PROFESSION_TITLE_MODAL_NAME = 'edit-profession-title-modal'
export const EDIT_BIOGRAPHY_MODAL_NAME = 'edit-biography-modal'
export const ADD_SPECIALTY_MODAL_NAME = 'add-specialty-modal'
export const ADD_TOOL_MODAL_NAME = 'add-tool-modal'

// Mentee profile
export const EDIT_POSITION_MODAL_NAME = 'edit-position-modal'
export const ADD_STARTUP_MODAL_NAME = 'add-startup-modal'
export const EDIT_SKILLS_MODAL_NAME = 'edit-skills-modal'
export const EDIT_CHALLENGES_MODAL_NAME = 'edit-challenges-modal'
export const EDIT_INTERESTS_MODAL_NAME = 'edit-interests-modal'
export const EDIT_LOOKING_FOR_MODAL_NAME = 'edit-looking-for-modal'

// Opportunities
export const OPPORTUNITIES_ACCESS_DENIED_MODAL_NAME =
  'opportunities-access-denied-modal'
